'use client'

import '@/lib/i18n/config'
import { ThemeProvider } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { theme } from '@/utils/theme'

export function Providers({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation()

  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .catch((error) => console.error(error))
    }

    if (typeof window !== 'undefined') {
      const savedLanguage = localStorage.getItem('i18nextLng')
      i18n.changeLanguage(savedLanguage || 'ja')
    }
    setHasMounted(true)
  }, [])

  if (!hasMounted) {
    return null
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
